import { Container, Row, Col } from "react-bootstrap"
import { Provider as JotaiProvider } from "jotai"
import TopBar from "./components/layout/TopBar"
import LeftNav from "./components/layout/LeftNav"
import BrowserWarning from "./components/BrowserWarning"
import { Suspense, useState } from "react"
import TenantProvider from "./components/tenancy/TenantProvider"
import AuthenticatedRoutes from "./components/layout/AuthenticatedRoutes"
import { useZoneIndicator } from "mco-zone-configurations/src/useZoneIndicator"
import LoadingMessage from "./components/layout/LoadingMessage"
import RdsKeepAlive from "./components/testing/RdsKeepAlive"

function App() {
	useZoneIndicator(true)

	const [showNav, setShowNav] = useState(true)
	const toggleNavVisibility = () => setShowNav(!showNav)

	return (
		<div className="App">
			<JotaiProvider>
				<Suspense fallback={<LoadingMessage />}>
					<RdsKeepAlive />
					<TenantProvider>
						<TopBar />
						<Container fluid>
							<Row>
								<LeftNav
									showNav={showNav}
									toggleNavVisibility={toggleNavVisibility}
								/>
								<Col
									className={`pr-0 ${
										showNav
											? "main-col-with-nav"
											: "main-col-no-nav"
									}`}
								>
									<BrowserWarning />
									<Container fluid>
										<AuthenticatedRoutes />
									</Container>
								</Col>
							</Row>
						</Container>
					</TenantProvider>
				</Suspense>
			</JotaiProvider>
		</div>
	)
}

export default App
